import { Mesh } from "../types/mesh";

export class Snapshot {
  mesh!: Mesh;

  constructor(mesh: Mesh) {
    this.mesh = mesh;
  }
}
